// Components==============
import { useRedux } from 'hooks/useRedux';
import React, { createContext, useEffect, useMemo, useState } from 'react';
// =========================

type GlobalTrainingUserContextType = {
  trainingUser: number;
  setTrainingUser: React.Dispatch<React.SetStateAction<number>>;
  shouldResetTrainingUser: boolean;
  setShouldResetTrainingUser: React.Dispatch<React.SetStateAction<boolean>>;
};

export const GlobalTrainingUserContext = createContext(
  {} as GlobalTrainingUserContextType
);

export default function GlobalTrainingUser({
  children,
}: {
  children: React.ReactNode;
}) {
  const userId = useRedux((state) => state?.authentication?.user?.id);

  const [trainingUser, setTrainingUser] = useState(userId || 0);
  const [shouldResetTrainingUser, setShouldResetTrainingUser] = useState(true);

  useEffect(() => {
    if (!shouldResetTrainingUser) {
      setTimeout(() => {
        setShouldResetTrainingUser(true);
      }, 250);
    }
  }, [shouldResetTrainingUser]);

  const value = useMemo(
    () => ({
      trainingUser,
      setTrainingUser,
      shouldResetTrainingUser,
      setShouldResetTrainingUser,
    }),
    [trainingUser, shouldResetTrainingUser]
  );

  return (
    <GlobalTrainingUserContext.Provider value={value}>
      {children}
    </GlobalTrainingUserContext.Provider>
  );
}
